export default __webpack_public_path__ + "static/media/neumorphicArrow.ce2587b6.svg";